export default "__VITE_ASSET__WYsJVdpW__"